define('areas/informationrequest/service/toastDCService',["require", "exports"], function (require, exports) {
    "use strict";
    var ToastDCService = (function () {
        function ToastDCService() {
        }
        ToastDCService.prototype.constructDCToast = function (type, text) {
            var toastIcon = '';
            switch (type) {
                case 'info': {
                    toastIcon = '<i class="fas fa-info-circle" > </i>';
                    break;
                }
                case 'success': {
                    toastIcon = '<i class="far fa-check-circle"></i>';
                    break;
                }
                case 'fail': {
                    toastIcon = '<i class="far fa-times-circle"></i>';
                    break;
                }
            }
            var toast1 = "<div class=\"toast-container1 " + type + "\">\n                <div class=\"toast-icon " + type + "\">\n                    <span class=\"icon-span\">\n                        " + toastIcon + "\n                    </span>\n\n                </div>\n                <div>\n                    <div class=\"toast-text-col\">\n                        <div class=\"toast-close-btn\">\n                            <i class=\"fas fa-times\"></i>\n                        </div>\n                        <div class=\"toast-text-row\">\n                            <span>" + text + "</span>\n                        </div>\n                    </div>\n                </div>\n            </div>";
            var toastOptions = {
                timeOut: 0,
                extendedTimeOut: 0,
                positionClass: "toast-top-center",
                tapToDismiss: true,
                allowHtml: true,
                iconClass: 'toast'
            };
            toastr.info(toast1, '', toastOptions);
        };
        return ToastDCService;
    }());
    exports.ToastDCService = ToastDCService;
});

